// extracted by mini-css-extract-plugin
export var formContainer = "_e0-0";
export var message = "_e0-1";